module.exports = __webpack_public_path__ + "img/atari1200_page6.4532093a.jpg";